import useServerList from '@/composables/useServerList'
import committeesApi from '@/services/api/committees'
import { COMMITTEE_FINANCIAL_ALL } from '@/constants/committeeFinancialFilter'

// Admin /committee-list page: server-side search / sort / pagination / financial tab, URL state.
export default function useCommitteesList() {
  return useServerList(committeesApi.getList, {
    defaultSort: 'name',
    defaultDirection: 'asc',
    defaultPerPage: 20,
    extraFilters: {
      is_financial: COMMITTEE_FINANCIAL_ALL
    }
  })
}



// WEBPACK FOOTER //
// ./src/composables/committees/useCommitteesList.js